import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = { class: "App-Styled-Form" }
const _hoisted_3 = { class: "App-User-StandartTest-Promp" }
const _hoisted_4 = { "txt-center": "" }
const _hoisted_5 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-User-StandartTest-Modal App-Unpadded",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": _ctx.showClose,
      "close-on-click-modal": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Standardized Tests",
      center: "",
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "close-delay": 200,
      "before-close": _ctx.closeModal,
      "close-on-press-escape": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.submit,
            size: "large",
            type: "primary",
            disabled: !_ctx.showSave || _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Save ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          always: true,
          "max-height": "600px"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_image, {
                    style: `width: 150px;`,
                    src: _ctx.img
                  }, null, 8, ["src"]),
                  _cache[2] || (_cache[2] = _createElementVNode("p", null, [
                    _createTextVNode(" Have you ever sat down for any standardized "),
                    _createElementVNode("br"),
                    _createTextVNode(" test? E.g. SAT, GMAT, etc ")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_radio_group, {
                      onChange: _ctx.changedHaveTakenTests,
                      modelValue: _ctx.haveTakenTests,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.haveTakenTests) = $event)),
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, {
                          class: "App-Test-Radio",
                          label: true,
                          size: "large"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("h4", null, "Yes"),
                              _createElementVNode("span", null, "I have done one or more tests")
                            ], -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio, {
                          class: "App-Test-Radio",
                          label: false,
                          size: "large"
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("h4", null, "No"),
                              _createElementVNode("span", null, "I have never done any.")
                            ], -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onChange", "modelValue"])
                  ]),
                  (_ctx.haveTakenTests === true)
                    ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.haveTakenTests === true)
                ? (_openBlock(), _createBlock(_component_el_form, {
                    key: 0,
                    onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                    class: "App-Styled-Form",
                    "label-position": 'top',
                    "label-width": "100px",
                    model: _ctx.form,
                    style: {"margin-top":"12px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.standardTests, (test, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createVNode(_component_el_row, {
                            align: "middle",
                            gutter: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "TestName",
                                    label: "Test Name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.form.standardTests[index].name,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.standardTests[index].name) = $event),
                                        placeholder: "SAT",
                                        "w-100": ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standarTests, (test) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              value: test.name,
                                              label: test.name,
                                              key: `${test.name}-ind`
                                            }, null, 8, ["value", "label"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "Score",
                                    label: "Score"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input_number, {
                                        "w-100": "",
                                        controls: false,
                                        placeholder: "300",
                                        modelValue: _ctx.form.standardTests[index].score,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.standardTests[index].score) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 2 }, {
                                default: _withCtx(() => [
                                  (index > 0)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.removeTest(index)),
                                        icon: "el-icon-delete",
                                        circle: "",
                                        size: "mini"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_button, {
                          type: "info",
                          "is-borderless": "",
                          round: "",
                          onClick: _ctx.addTest,
                          size: "small",
                          icon: "el-icon-plus"
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("Add Test Score", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model"]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "close-on-click-modal", "onOpen", "before-close"])
  ]))
}